export default __webpack_public_path__ + "static/media/tg.dd2e2128.jpg";